import { render, staticRenderFns } from "./DataGridDeleteButton.vue?vue&type=template&id=833d1c0e&"
import script from "./DataGridDeleteButton.vue?vue&type=script&setup=true&lang=js&"
export * from "./DataGridDeleteButton.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
